module.exports = __webpack_public_path__ + "img/51385812dfdba75414af0f685caf51fd.1f193315.png";